import { render, staticRenderFns } from "./CustomerServiceInformation.vue?vue&type=template&id=652d68c5&scoped=true&"
import script from "./CustomerServiceInformation.vue?vue&type=script&lang=ts&"
export * from "./CustomerServiceInformation.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerServiceInformation.vue?vue&type=style&index=0&id=652d68c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652d68c5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VDivider,VIcon,VImg})
